<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">按筛选充值</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-row>
          <el-col :span="24" class="item">
            {{infoStr}}
          </el-col>
        </el-row>
        <div style="height: 10px;"></div>
        <el-row>
          <el-col :span="24" class="item">
            每人充值:
            <el-input size="mini" v-model="elderlyClassValue" placeholder="输入充值金额" style="width: 150px;"></el-input>
            总金额:{{this.elderlyClassValue*this.arr.length}}
          </el-col>

        </el-row>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">确认充值</el-button>
      </div>
    </div>

    <div v-if="showModal" class="mask">
      <div class="lodingsIcon">
        <i class="el-icon-loading"></i><span>正在处理，请等待。。。</span>
      </div>
    </div>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: 'Add',
  data() {
    return {

      loading: false,
      showModal:false,

      elderlyClassCode:'',
      elderlyClassName:'',
      elderlyClassValue:0,
      zoneCode:'',
      zoneTitle:'',

      tableData:[],
      totalItems:0,
      pageSize: 20,
      currentPage: 1,

      infoStr:'',

      arr:[],

    }
  },
  components:{

  },
  methods: {
    init(classValue,arr){

      this.elderlyClassValue = classValue;

      this.arr = arr;

      this.infoStr = "将给"+arr.length+"位老人充值";

    },
    closeSelf() {
      this.$emit("closeAddMulSelectConfirm");
    },


    confirm(){

      if(this.elderlyClassValue == '' || this.elderlyClassValue == 0){
        this.$message.info("输入正确的充值金额");
        return;
      }

      if(!this.isNumeric(this.elderlyClassValue)){
        this.$message.info("输入正确的充值金额");
        return;
      }

      if(this.arr.length == 0){
        this.$message.info("请选择老人");
        return;
      }

      this.$confirm('确定充值?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.addSubmit()
      }).catch(e=>e)


    },

    addSubmit(){

      this.showModal =true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Recharge/GovAddMulSelect",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
          addBalance:this.elderlyClassValue,
          arr:this.arr,
        }
      }).then(
          (response) => {

            this.showModal = false;

            if (response.data.error == 0) {
              this.$emit("closeAddMulSelectConfirm");
              this.$emit("closeAndList");

            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          }
      )


    },

    isNumeric (str) {
      var newPar = /^(-|\+)?\d+(\.\d+)?$/;
      return newPar.test(str);
    },

  }
}


</script>
<style lang="scss" scoped>

</style>
